import { buildMode, BuildMode } from "@/services/buildMode";

export type FacebookPixel = (command: string, param: string, extraData: unknown) => void;

// See https://www.facebook.com/business/help/402791146561655?id=1205376682832142

enum Event {
  AddToCart = "AddToCart",
  NewOrder = "Purchase",
  CompleteRegistration = "CompleteRegistration",
  NewMarketplaceListing = "NewMarketplaceListing",
  NewMarketplaceListingOver100Czk = "NewMarketplaceListingOver100Czk",
}

const trackEvent = async (event: Event, extraData: unknown = undefined): Promise<void> => {
  if (isTrackingAllowed()) {
    const pixel = getFacebookPixel();
    if (pixel !== undefined) {
      pixel("track", event, extraData);
    }
  }
};

const isTrackingAllowed = (): boolean => {
  const allowedModes = [BuildMode.Production];
  return allowedModes.includes(buildMode);
};

const getFacebookPixel = (): FacebookPixel | undefined => {
  if (typeof window.fbq === "undefined") {
    console.warn("Facebook Pixel required, but not found.");
    return undefined;
  } else {
    return window.fbq;
  }
};

export default {
  trackEvent,
  Event,
};
